import React, { Component } from "react";
import { Nav, Loader } from "ui-kit-ck-consultant";
import FadeIn from "react-fade-in/lib/FadeIn";

import ShowOptionsNGRA from "../../../components/general/ShowOptionsNGRA-v2";

import MainFigures from "../../../components/specialties/caravaning/MainFigures";
import TreatmentDelays from "../../../components/specialties/caravaning/TreatmentDelays";
import AverageAgeOfCurrentCases from "../../../components/specialties/caravaning/AverageAgeOfCurrentCases";
import DetailOfVolumetriesAndCost from "../../../components/specialties/caravaning/DetailOfVolumetriesAndCost";
import Savings from "../../../components/specialties/caravaning/Savings";

import axiosConfig from "../../../utils/axiosConfig";
import filterStore from "../../../stores/filterStore";

export class Caravaning extends Component {
  constructor(props) {
    super(props);
    const saved = filterStore.getState().getPageState("caravaning");
    this.state = saved || {
      isLoad: false,
      mainFigures: [],
      treatmentDelays: [],
      averageAgeOfCurrentCases: [],
      detailOfVolumetriesAndCost: [],
      savings: [],
    };
  }

  componentWillUnmount() {
    filterStore.getState().setPageState("caravaning", this.state);
  }

  handleDataChange = (data) => {
    filterStore.getState().setPageFilters("caravaning", data);
    this.setState(
      {
        year: data.year,
        network: data.network,
        group: data.group,
        region: data.region,
        agency: data.agency,
        user: data.user,
        company: data.company,
      },
      this.getData
    );
  };

  getData = () => {
    this.setState(
      {
        isLoad: true,
      },
      () => {
        axiosConfig("specialties/caravaning/get-data", {
          data: {
            year: this.state.year,
            network: this.state.network,
            group: this.state.group,
            region: this.state.region,
            agency: this.state.agency,
            user: this.state.user,
            company: this.state.company,
          },
        })
          .then((res) => {
            if (res.data.success) {
              this.setState({
                isLoad: false,
                mainFigures: res.data.data.mainFigures,
                treatmentDelays: res.data.data.treatmentDelays,
                averageAgeOfCurrentCases:
                  res.data.data.averageAgeOfCurrentCases,
                detailOfVolumetriesAndCost:
                  res.data.data.detailOfVolumetriesAndCost,
                savings: res.data.data.savings,
              });
            } else {
              this.setState({
                isLoad: false,
                mainFigures: [],
                treatmentDelays: [],
                averageAgeOfCurrentCases: [],
                detailOfVolumetriesAndCost: [],
                savings: [],
              });
            }
          })
          .catch(() => {
            this.setState({
              isLoad: false,
              mainFigures: [],
              treatmentDelays: [],
              averageAgeOfCurrentCases: [],
              detailOfVolumetriesAndCost: [],
              savings: [],
            });
          });
      }
    );
  };

  render() {
    return (
      <>
        <FadeIn>
          <Nav title="Caravaning" className="mb-10 mb-20-xl" />
          <ShowOptionsNGRA
            isChange={true}
            className="mb-10 mb-20-xl"
            onDataChange={this.handleDataChange}
            initialFilters={filterStore.getState().getPageFilters("caravaning")}
            isYear={true}
            isUser={true}
            isCompany={true}
            visibilityRole={this.props.visibilityRole}
            visibilityType={this.props.visibilityType}
            preloadRole={this.props.preloadRole}
            preloadType={this.props.preloadType}
            limitUserType={this.props.limitUserType}
            limitUserRole={this.props.limitUserRole}
            userType={[1, 2, 3]}
            isDefaultAllUser={true}
          />
          <MainFigures year={this.state.year} data={this.state.mainFigures} />
          <TreatmentDelays
            year={this.state.year}
            data={this.state.treatmentDelays}
          />
          <AverageAgeOfCurrentCases
            year={this.state.year}
            data={this.state.averageAgeOfCurrentCases}
          />
          <DetailOfVolumetriesAndCost
            year={this.state.year}
            data={this.state.detailOfVolumetriesAndCost}
          />
          <Savings year={this.state.year} data={this.state.savings} />
        </FadeIn>
        <Loader show={this.state.isLoad} />
      </>
    );
  }
}

export default Caravaning;
